<article 
  class="card-1"
  [style.background-image]="'url(' + img() + ')'"
  [attr.data-index]="(indexCard() + 1)"
>
  <div class="card-1__content">
    @if(isSaturated()) {
      <app-satured-chip />
    }
    @if(isVerySaturated()) {  
      <app-very-satured-chip />
    }
    
    @if (title()) {
      <!-- TODO: AÑADIR VIEW TRANSITIONS CUANDO LA DATA NO SEA MOCKED -->
      <h2 
        class="card-1__title"
      >
        {{ title() | translate }}
      </h2>
    }
  </div>
</article>
